import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { take } from 'rxjs';
import { UserAreaModel } from '../../../models/user-area.model';
import { AlertService } from '../../../services/alert.service';
import { UserAreaService } from '../../../services/user-area.service';
import { UserService } from '../../../services/user.service';
import { RedeemMemberAreaComponent } from '../../shared-components/redeem-member-area/redeem-member-area.component';

@Component({
  selector: 'app-member-areas',
  templateUrl: './member-areas.component.html',
  styleUrl: './member-areas.component.scss',
  standalone: false,
})
export class MemberAreasComponent implements OnInit {
  areas: UserAreaModel[] = [];
  loading = true;

  showRedeem = false;
  redeemCodeValue = '';
  redeemLoading = false;

  constructor(
    private userAreaService: UserAreaService,
    private router: Router,
    private alertService: AlertService,
    public userService: UserService,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.loadMyUserAreas();
  }

  private loadMyUserAreas(): void {
    this.loading = true;
    this.userAreaService
      .getMyUserAreas()
      .pipe(take(1))
      .subscribe({
        next: areas => {
          this.areas = areas;
          this.loading = false;
        },
        error: () => {
          this.alertService.showErrorAlert(
            'Mitgliederbereiche konnten nicht geladen werden.'
          );
        },
      });
  }

  toggleRedeem(): void {
    this.showRedeem = !this.showRedeem;
  }

  showRedeemCodeDialog(): void {
    const dialogRef = this.dialogService.open(RedeemMemberAreaComponent, {
      width: '600px',
      data: {
        type: 'promo',
      },
    });
    dialogRef.onClose.subscribe((response: boolean) => {
      if (response) {
        this.loadMyUserAreas();
      }
    });
  }

  onAddArea() {
    this.router.navigate(['/administration/user-areas/create']);
  }

  goToArea(area: UserAreaModel): void {
    this.router.navigate(['/member-areas', btoa(String(area.id))]);
  }

  getAreaBackgroundStyle(areaId: number): { [key: string]: string } {
    const area = this.areas.find(a => a.id === areaId);
    if (!area || !area.image) {
      return {};
    }

    return {
      'background-image': `url(${URL.createObjectURL(area.image)})`,
    };
  }

  getAreaImage(area: UserAreaModel): string {
    if (!area.image) {
      return '';
    }
    return URL.createObjectURL(area.image);
  }

  onRedeemCode(): void {
    if (!this.redeemCodeValue) return;
    this.redeemLoading = true;
    this.userAreaService
      .redeemCode(this.redeemCodeValue.trim())
      .pipe(take(1))
      .subscribe({
        next: res => {
          this.redeemLoading = false;
          this.redeemCodeValue = '';
          this.showRedeem = false;
          this.alertService.showSuccessAlert(
            res.message || 'Bereich freigeschaltet.'
          );
          this.loadMyUserAreas();
        },
        error: err => {
          this.redeemLoading = false;
          this.alertService.showErrorAlert(
            err?.message || 'Code konnte nicht eingelöst werden.'
          );
        },
      });
  }
}
